<template>
	<div class="h-panel-body padding font-bold">
		<div class="h-panel-bar"><span class="h-panel-title">资产卡片</span></div>
		
	 
		<div class="topselectbox">
			
			<!-- <Loading text="Loading" :loading="loading"> -->
			<div class="topselect02">
				时间：<a-month-picker v-model:value="formData.month" :format="'YYYY年MM月'" @change="loadList" />&nbsp;
				资产类型：<a-select   v-model="formData.propertyClass" style="width:200px;padding-right:5px;" :options="propertyClassData" > </a-select>&nbsp;
				<span  v-if='formData.propertyClass==1'>资产类别：</span><a-select v-if='formData.propertyClass==1'  v-model="formData.propertyType" 
				style="width:200px;padding-right:5px;" :options="propertyTypeData"  allowClear> </a-select>
				<button class="h-btn " @click="loadList">查询</button> 
				<button class="h-btn h-btn-blue" @click="showDrawer(undefined)">新增</button> 
				<button class="h-btn " @click="createVoucher()" :disabled="propertyDisable" >生成资产凭证</button> 
				<button class="h-btn " @click="handleDevalue()" :disabled="devalueDisable" >生成折旧凭证</button> 
				<button class="h-btn " @click="loadList">刷新</button> 
			</div>
			<!-- </Loading> -->
		</div>

		<div class="tablebox">
			
			<Table :datas="datas" ref="table" :height="600" :border="true" @trdblclick="handleTBRow"
				:checkbox="mode=='checkbox'" :selectRow="mode=='rowSelect'" selectWhenClickTr @select="checkSelect">
				<TableItem title="编码" prop="code" :width="80" />
				<TableItem title="名称" align="center" prop="name" :width="100" />
				<TableItem title="类别"   align="center" :width="100" >
					<template #default="{ data }"> 
						<span>
							{{  data.propertyType==1?"房屋、建筑物":
								data.propertyType==2?"机器机械生产设备":
								data.propertyType==3?"器具、工具、家具":
								data.propertyType==4?"运输工具":
								data.propertyType==5?"电子设备":
								data.propertyType==6?"其他固定资产":"-"
							}}
						</span> 
					</template>
				</TableItem>
				<TableItem title="状态"   align="center" :width="75" >
					<template #default="{ data }"> 
						<span   >
							{{  data.status==1?"正常":
								data.status==2?"已清理":"-"
							}}</span> 
					</template>
				</TableItem>
				<TableItem title="原值" prop="basicAmount" align="center" :width="100" />
				<TableItem title="期初累计折旧" prop="devalueAlreadyAmount" align="center" :width="100" />
				<!-- <TableItem title="期末累计折旧" prop="balance" align="center" :width="100" /> -->
				<TableItem title="月折旧" prop="devalueAvgAmount" align="center" :width="100" />  
				<TableItem title="预计使用期限" prop="beUseNum" align="center" :width="100" />  
				<TableItem title="已使用期" prop="devalueUseNum" align="center" :width="75" />  
				<TableItem title="残值" prop="devalueLaterAmount" align="center" :width="100" />  
				<TableItem title="残值率" prop="devalueRate" align="center" :width="75" >  
					<template #default="{ data }"> 
						{{ data.devalueRate +'%'}}
					</template>
				</TableItem>
				<TableItem title="减值准备" prop="devalueReadyAmount" align="center" :width="100" />  
				<TableItem title="折旧方法"   align="center" :width="100" >
					<template #default="{ data }"> 
						<span   >
							{{  data.devalueType==1?"不提折旧":
								data.devalueType==2?"平均年限法":"-"
							}}</span> 
					</template>
				</TableItem>
				<TableItem title="创建时间" prop="createTime" align="center" :width="100" />
				<TableItem title="资产凭证"   align="center" :width="80" >
					<template #default="{ data }">
						<router-link v-if="data.propertyVoucherId" tag="button" :to="{name:'VoucherForm', params: { voucherId: data.propertyVoucherId}}" class="h-btn h-btn-green" style="padding:5px 10px;">查看</router-link>
					</template>
				</TableItem>
				<TableItem title="折旧凭证"   align="center" :width="80" >
					<template #default="{ data }">
						<router-link v-if="data.devalueVoucherId" tag="button" :to="{name:'VoucherForm', params: { voucherId: data.devalueVoucherId}}" class="h-btn h-btn-green" style="padding:5px 10px;">查看</router-link>
					</template>
				</TableItem>
				<TableItem title="操作" :width="100" align="center">
					<template #default="{ data }">
						<span style="color:#2d7bf4; cursor: pointer;" @click="showDrawer(data)">编辑</span> &nbsp;&nbsp;
						<span style="color:#2d7bf4; cursor: pointer;" @click="del(data.id)">删除</span>
					</template>
				</TableItem>
				<template #empty>
					自定义提醒：暂时无数据
				</template>
			</Table>
		</div>
		<div class="yema" style="margin-top:15px;" v-show="datas.length>0">
			<Pagination v-model="pagination" @change="currentChange"  align="center" :small="true" layout="total,sizes,pager"></Pagination>
		</div>
	 
		<Modal title="资产信息" v-model="visible"  cancelText="取消" okText="确认" :width="940" :closeOnMask="false" >
					<div slot="header">资产信息</div>
					 <Form :label-width="120" :mode="'threecolumn'" :model="showdata"   ref="form" :top="0.2" showErrorTip>
						 <div text="重要文件" type="primary" closable v-if="showdata.id!=undefined " >
							<img v-if="showdata.status==1" src="../../assets/normaluse.png"  class="stamp-image"/> 
							<img v-if="showdata.status==2" src="../../assets/clear.png"  class="stamp-image"/> 
						</div>
						<div class="info-title"  >基本信息</div>
						<FormItem label="资产编码" prop="code">
							<input type="text" v-model="showdata.code"   /> 
						</FormItem>
						<FormItem label="资产名称" prop="name">
							<input type="text" v-model="showdata.name"   /> 
						</FormItem>
						<FormItem label="资产类型" prop="propertyClass">
							<Select v-model="showdata.propertyClass" :datas="propertyClassList"  :disabled="showdata.id!=undefined"></Select>
						</FormItem>
						<FormItem label="资产类别" prop="propertyType">
							<Select v-model="showdata.propertyType" :datas="propertyTypeList"></Select>
						</FormItem>
						<FormItem label="录入期间" prop="accountDateStr">
							<input type="text" v-model="showdata.accountDateStr"  :disabled="true"  /> 
						</FormItem>
						<FormItem label="清理期间" prop="clearDateStr">
							<input type="text" v-model="showdata.clearDateStr" :disabled="true" /> 
						</FormItem>
						<FormItem label="规格型号" prop="spec">
							<input type="text" v-model="showdata.spec"  />  
						</FormItem>
						<FormItem label="开始使用日期" prop="startTime">
							<DatePicker v-model="showdata.startTime" :format="'YYYY-MM-DD'"  @change="setAccountDate()"></DatePicker>
						</FormItem> 
							 
						 <a-divider type="horizontal" /> 
						 <div class="info-title"  >折旧方式</div>

						<FormItem label="折旧方式" prop="devalueType">
							<Select v-model="showdata.devalueType" :datas="devalueTypeList"></Select>
						</FormItem>
						<FormItem label="预计使用期限" prop="beUseNum">
							<NumberInput v-model="showdata.beUseNum"  :min="0" style="width:90px;float:left;" ></NumberInput>
							<span style="float:left;font-size:13px;line-height:31px;color:#555555" >&nbsp;&nbsp;期</span>
						</FormItem>
						<FormItem label="减值准备科目" prop="jzzbSubjectId">
							<a-select v-model="showdata.jzzbSubjectId" style="width:100%" :options="subjectData" show-search :filter-option="filterOption">
							</a-select>
						</FormItem>
						<FormItem label="固定资产科目" prop="gdzcSubjectId">
							<a-select v-model="showdata.gdzcSubjectId" style="width:100%" :options="subjectData" show-search :filter-option="filterOption">
							</a-select>
						</FormItem>
						<FormItem label="累计折旧科目" prop="ljzjSubjectId">
							<a-select v-model="showdata.ljzjSubjectId" style="width:100%" :options="subjectData" show-search :filter-option="filterOption">
							</a-select>
						</FormItem>
						<FormItem label="折旧费用科目" prop="zjfySubjectId">
							<a-select v-model="showdata.zjfySubjectId" style="width:100%" :options="subjectData" show-search :filter-option="filterOption">
							</a-select>
						</FormItem>
						<FormItem label="税金科目" prop="sjSubjectId">
							<a-select v-model="showdata.sjSubjectId" style="width:100%" :options="subjectData" show-search :filter-option="filterOption">
							</a-select>
						</FormItem>
						<FormItem label="资产购入对方科目" prop="zcgrdfkmSubjectId">
							<a-select v-model="showdata.zcgrdfkmSubjectId" style="width:100%" :options="subjectData" show-search :filter-option="filterOption">
							</a-select>
						</FormItem>
						<FormItem label="资产清理科目" prop="zcqlSubjectId">
							<a-select v-model="showdata.zcqlSubjectId" style="width:100%" :options="subjectData" show-search :filter-option="filterOption">
							</a-select>
						</FormItem> 

						 <a-divider type="horizontal" /> 
						 <div class="info-title"  >原值、净值、累计折旧</div>
						
						<FormItem label="原值" prop="basicAmount">
							<NumberInput v-model="showdata.basicAmount" :min="0"  @change="amountCalc(showdata)" ></NumberInput>
						</FormItem> 
						<FormItem label="残值率(%)" prop="devalueRate">
							<NumberInput v-model="showdata.devalueRate" :min="0" :max="100" :step="1" :useOperate="true"  @change="amountCalc(showdata)"></NumberInput>
						</FormItem>
						<FormItem label="预计残值" prop="devalueLaterAmount">
							<NumberInput v-model="showdata.devalueLaterAmount" :min="0" :disabled="true" ></NumberInput>
						</FormItem>
						<FormItem label="税额" prop="taxAmount">
							<NumberInput v-model="showdata.taxAmount" :min="0" ></NumberInput>
						</FormItem>
						<FormItem label="减值准备" prop="devalueReadyAmount">
							<NumberInput v-model="showdata.devalueReadyAmount" :max="showdata.basicAmount" :min="0" @change="amountCalc(showdata)" ></NumberInput>
						</FormItem>
						<FormItem label="已折旧期间" prop="devalueUseNum">
							<NumberInput v-model="showdata.devalueUseNum" :min="0"  :step="1" :useOperate="true" @change="amountCalc(showdata)" ></NumberInput>
						</FormItem>
						<FormItem label="期初累计折旧" prop="devalueAlreadyAmount">
							<NumberInput v-model="showdata.devalueAlreadyAmount" :min="0" @change="changeDevalueAlreadyAmount(showdata)" ></NumberInput>
						</FormItem>
						<FormItem label="期初净值" prop="devalueNowAmount">
							<NumberInput v-model="showdata.devalueNowAmount" :min="0" :disabled="true" ></NumberInput>
						</FormItem>
						<FormItem label="月折旧" prop="devalueAvgAmount">
							<NumberInput v-model="showdata.devalueAvgAmount" :min="0"  :disabled="true"></NumberInput>
						</FormItem>
						<FormItem label="备注" prop="remark" single>
							<textarea  v-model="showdata.remark" ></textarea >
						</FormItem> 
					 </Form>
					<div slot="footer">
						<Button color="primary" @click="onSave()">保存</Button>
						<Button color="green" v-if="showdata.id!= undefined " @click="setStatus(showdata.id)">{{showdata.status==1?'清理资产':'取消清理'}}</Button>
						<Button @click="visible=false">关闭</Button> 
					</div>
			</Modal>

	</div>
</template>

<script>


import moment from 'moment'
import { mapState } from 'vuex'
import 'moment/locale/zh-cn';
export default {
	name: "Salarymanage",
	data() {
		return {
			dataList: {},
			datas: [
			],
			visible: false,
			hildrenDrawer: false,
            subjectData:[],
            voucherSelect: [],
            kmFiler: "",
			loading:false,
			formData:{
				month:moment(),
				propertyClass:1,
				propertyType:undefined
			},
			propertyClassData:[
				{ value:1,label:"固定资产" },
				{ value:2,label:"无形资产" },
				{ value:3,label:"待摊费用" }
			],
			propertyTypeData:[
				{ value:1,label:"房屋、建筑物" },
				{ value:2,label:"机器机械生产设备" },
				{ value:3,label:"器具、工具、家具" },
				{ value:4,label:"运输工具" },
				{ value:5,label:"电子设备" },
				{ value:6,label:"其他固定资产" }, 
			],
			pagination:{
				page:1,
				size:20,
				total:0
			},
			 mode: 'checkbox',
			devalueTypeList:[
				{ title: "不提折旧" , key: 1 },
				{ title: "平均年限法" , key: 2 },
			],
			propertyTypeList:[
				{ title: "房屋、建筑物" , key: 1 },
				{ title: "机器机械生产设备" , key: 2 },
				{ title: "器具、工具、家具" , key: 3 },
				{ title: "运输工具" , key: 4 },
				{ title: "电子设备" , key: 5 },
				{ title: "其他固定资产" , key: 6 },
			],
			propertyClassList:[
				{ title: "固定资产" , key: 1 },
				{ title: "无形资产" , key: 2 },
				{ title: "待摊费用" , key: 3 },
			],
			vcode:0,
			showdata: {  
			}, 
			propertyDisable:false,
			devalueDisable:false

		}
	},
	computed: {
		...mapState(['User', 'currentAccountSets']),
		date() {
			return moment(this.accountDate);
		}
	},
	created() { 
		
        this.subjectLoad();
		this.loadList(); 
	},
	mounted() {

	},
	methods: {
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        subjectLoad() {
			this.$Loading();
            this.$api.setting.subject.voucherSelect({showAll: true}).then(({data}) => {
                this.voucherSelect = data;	
				this.$Loading.close();
				
                if(this.voucherSelect!=undefined && this.voucherSelect.length>0){
                    for(var i = 0;i<this.voucherSelect.length;i++){
                        var ops = {
                            value:this.voucherSelect[i].id,
                            label:this.voucherSelect[i].subjectFullName
                        }
                        this.subjectData.push(ops);
                    }
                }
            });
        },
		loadList() { 
			
			var accountSetsId = this.User.accountSetsId;
			 var parmas = {
					accountSetsId:accountSetsId,
					accountDate:this.formData.month.format('YYYY-MM-DD'),
					current:this.pagination.page,
					size:this.pagination.size,
					propertyClass:this.formData.propertyClass,
					propertyType:this.formData.propertyType
				} 
 
			this.$api.propertys.list(parmas).then( res   => { 
				if(res.code == 200){
					this.datas = res.data.records;
					this.pagination.page = res.data.current; 
					this.pagination.total = res.data.total; 
					this.datas.forEach(item =>{
						item.accountDateStr=moment(String(item.accountDate)).format('YYYY年MM月');
					})
				} 
			})
		},
		currentChange(value){
			this.pagination.page= value.cur; 
			this.pagination.size=value.size;
			this.loadList();

		},
		setAccountDate(){
			if(this.showdata.startTime!=undefined){
				this.$set(this.showdata, 'accountDateStr',moment(String(this.showdata.startTime)).format('YYYY年MM月'));
				this.$set(this.showdata, 'accountDate',moment(String(this.showdata.startTime)).format('YYYY-MM-')+'01');
			}
		},
		showDrawer(data) {
			this.visible = true;   
            if(data== undefined || data.id==undefined){
				var now = new Date().toLocaleDateString();
                this.showdata={
					beUseNum:12,
					propertyClass:1,
					startTime:now,
					accountDateStr: moment(String(now)).format('YYYY年MM月'),
					accountDate:moment(String(now)).format('YYYY-MM-')+'01',
					devalueType:1,
					gdzcSubjectId:undefined,
					zjfySubjectId:undefined,
					jzzbSubjectId:undefined,
					ljzjSubjectId:undefined,
					sjSubjectId:undefined,
					zcgrdfkmSubjectId:undefined,
					zcqlSubjectId:undefined
				};
				//几个科目给默认值
				console.log(this.voucherSelect); 
				this.voucherSelect.forEach(item =>{
					if(item.code == "1601"){ 
						//固定资产科目
						this.showdata.gdzcSubjectId = item.id;
					}
					if(item.code == "560207"){ 
						//折旧费用科目
						this.showdata.zjfySubjectId = item.id;
					}
					if(item.code == "1603"){
						//减值准备
						this.showdata.jzzbSubjectId =item.id;
					}
					if(item.code == "1602"){ 
						//累计折旧
						this.showdata.ljzjSubjectId = item.id;
					}
					if(item.code == "22210101"){ 
						//税金科目
						this.showdata.sjSubjectId = item.id;
					}
					if(item.code == "1002"){ 
						//资产购入对方科目
						this.showdata.zcgrdfkmSubjectId = item.id;
					}
					if(item.code == "1606"){ 
						//资产清理科目
						this.showdata.zcqlSubjectId = item.id;
					}
				});

            }else{
			    this.showdata = data; 
            }
		},
		//计算折旧金额
		amountCalc(data){
			if(data.devalueType == undefined){
				this.$message.error('请选择折旧方式!');
			}else{ 
				//月折旧 = （固定资产原价 - 预计净残值 - 已计提的减值准备 ） ÷ 预计使用年限
				if(data.beUseNum!=undefined && data.beUseNum !=0){
						
					if(data.devalueRate!=undefined && data.devalueRate>0  &&
						data.basicAmount!=undefined && data.basicAmount>0  
					){ 
						//预计残值
						var devalueLaterAmount =( data.basicAmount *  data.devalueRate  / 100).toFixed(2) ;
						this.$set(this.showdata, 'devalueLaterAmount',devalueLaterAmount);
						//月折旧
						var devalueAvgAmount =0;
						if(data.devalueType ==2 ){
							//判断减值准备
							if(data.devalueReadyAmount!=undefined && data.devalueReadyAmount!=0){
								devalueAvgAmount = (( data.basicAmount - devalueLaterAmount - data.devalueReadyAmount) / data.beUseNum).toFixed(2);
							}else{
								devalueAvgAmount = (( data.basicAmount - devalueLaterAmount) / data.beUseNum).toFixed(2);
							}
						}
						this.$set(this.showdata, 'devalueAvgAmount',devalueAvgAmount);
						

						//已折旧期间
						if(data.devalueUseNum!=undefined && data.devalueUseNum !=0){
							//计算累计折旧
							var devalueAlreadyAmount = (devalueAvgAmount * data.devalueUseNum).toFixed(2)
							
							this.$set(this.showdata, 'devalueAlreadyAmount',devalueAlreadyAmount);
							//计算期初净值
							if(data.devalueReadyAmount!=undefined && data.devalueReadyAmount!=0){
								this.$set(this.showdata, 'devalueNowAmount',(data.basicAmount- devalueAlreadyAmount - data.devalueReadyAmount).toFixed(2));
							}else{
								this.$set(this.showdata, 'devalueNowAmount',(data.basicAmount - devalueAlreadyAmount).toFixed(2) );
							}
						}else{
							//计算期初净值
							if(data.devalueReadyAmount!=undefined && data.devalueReadyAmount!=0){
								this.$set(this.showdata, 'devalueNowAmount',(data.basicAmount -  data.devalueReadyAmount).toFixed(2));
							}else{
								this.$set(this.showdata, 'devalueNowAmount',data.basicAmount );
							}
						}
					}

				}else{
					this.$message.error('预计使用期限不能为0!'); 
				}
				 
			}

		},
		changeDevalueAlreadyAmount(data){
			if(data.devalueReadyAmount!=undefined && data.devalueReadyAmount!=0){
				this.$set(this.showdata, 'devalueNowAmount',(data.basicAmount -  data.devalueReadyAmount).toFixed(2));
			}else{
				this.$set(this.showdata, 'devalueNowAmount',data.basicAmount );
			} 
		},
		onClose() {
			this.visible = false;
		},
		//保存资产信息
		onSave() {
			var showdata = this.showdata;
			showdata.accountSetsId = this.User.accountSetsId;
			var that = this;
			if(showdata.startTime!=undefined){
				showdata.startTime = moment(String(this.showdata.startTime)).format('YYYY-MM-DD');
			}
			if(showdata.cleaDate!=undefined){
				showdata.cleaDate = moment(String(this.showdata.cleaDate)).format('YYYY-MM-DD');
			}
			if(showdata.id!=undefined){
				this.$api.propertys.edit(showdata).then(data => {
					if (data.code == 200) {
						that.loadList();
						this.$message.success('编辑成功');
						this.visible = false;
					} else {
						this.$message.error('编辑失败');
					}
				})
			}else{
				this.$api.propertys.add(showdata).then(data => {
					if (data.code == 200) {
						that.loadList();
						this.$message.success('添加成功');
						this.visible = false;
					} else {
						this.$message.error('添加失败');
					}


				})
			}
 

		},
		 //变更状态
		setStatus(id){
			this.$Confirm("确认变更状态?").then(() => {
				this.$api.propertys.setStatus(id).then(res => {
					if(res.code==200){
						this.showdata= res.data;
					}
				})
			});
		},
		//删除资产
        del(id) { 
			this.$Confirm("确认删除?").then(() => {
				this.$api.propertys.del(id).then(() => {
					this.loadList();
				})
			})
		},
		//生成资产凭证
		createVoucher(){
			var selecttion = this.$refs.table.getSelection(); 
			if(selecttion==undefined || selecttion.length ==0){
				this.$message.error('请选中记录!');
			} 
			this.$Confirm("确认生成凭证?").then(() => {
			//要保存的凭证数组
			var datasList = new Array();  
			selecttion.forEach(item =>{
				var detailsDatas = new Array(); 
				var obj = {
					auditMemberId:0,
					word: "记",
					remark:"",
					voucherDate: item.startTime,
					carryForward:false, 
					propertyId:item.id
				};
				if(item.status==1){
					//购入项
					var zc = {
						auxiliary:[],
						auxiliaryTitle:"",
						debitAmount:item.basicAmount,
						creditAmount:0,
						direction:"借",
						summary:"购入"+item.name,  
						subjectId:item.gdzcSubjectId, 
					}
					detailsDatas.push(zc);
					//累计折旧项
					if(item.devalueUseNum!=null && item.devalueUseNum>0 && item.devalueAlreadyAmount !=undefined && item.devalueAlreadyAmount >0){
						var zj = {
							auxiliary:[],
							auxiliaryTitle:"",
							debitAmount:0,
							creditAmount:item.devalueAlreadyAmount,
							direction:"贷",
							summary:"购入"+item.name,  
							subjectId:item.ljzjSubjectId 
						}
						detailsDatas.push(zj);
					}
					//减值准备
					if(item.devalueReadyAmount!=undefined && item.devalueReadyAmount>0){
						var zb = {
							auxiliary:[],
							auxiliaryTitle:"",
							debitAmount:0,
							creditAmount:item.devalueReadyAmount,
							direction:"贷",
							summary:"购入"+item.name,  
							subjectId:item.jzzbSubjectId
						}
						detailsDatas.push(zb);
					}
					//期初净值
					if(item.devalueNowAmount!=undefined && item.devalueNowAmount>0){
						var jz = {
							auxiliary:[],
							auxiliaryTitle:"",
							debitAmount:0,
							creditAmount:item.devalueNowAmount,
							direction:"贷",
							summary:"购入"+item.name,  
							subjectId:item.zcgrdfkmSubjectId
						}
						detailsDatas.push(jz);
					}
				}else if(item.status ==2){
					//期初净值-入
					var ql = {
						auxiliary:[],
						auxiliaryTitle:"",
						debitAmount:item.devalueNowAmount,
						creditAmount:0,
						direction:"借",
						summary:"清理"+item.name,  
						subjectId:item.zcqlSubjectId, 
					}
					detailsDatas.push(ql);
					//累计折旧项-入
					if(item.devalueUseNum!=null && item.devalueUseNum>0 && item.devalueAlreadyAmount !=undefined && item.devalueAlreadyAmount >0){
						var zj = {
							auxiliary:[],
							auxiliaryTitle:"",
							debitAmount:item.devalueAlreadyAmount,
							creditAmount:0,
							direction:"借",
							summary:"清理"+item.name,  
							subjectId:item.ljzjSubjectId 
						}
						detailsDatas.push(zj);
					}
					//减值准备
					if(item.devalueReadyAmount!=undefined && item.devalueReadyAmount>0){
						var zb = {
							auxiliary:[],
							auxiliaryTitle:"",
							debitAmount:item.devalueReadyAmount,
							creditAmount:0,
							direction:"借",
							summary:"入" + item.name,  
							subjectId:item.jzzbSubjectId
						}
						detailsDatas.push(zb);
					}

					//固定资产->出
					var ql2 = {
						auxiliary:[],
						auxiliaryTitle:"",
						debitAmount:0,
						creditAmount:item.basicAmount,
						direction:"贷",
						summary:"清理" + item.name,  
						subjectId:item.gdzcSubjectId 
					}
					detailsDatas.push(ql2);

				}else{
					this.$message.error('资产'+ item.name +'状态错误!');
					return ;
				}
				obj.details = detailsDatas;
				datasList.push(obj);
			})


				this.$api.propertys.generateVoucher(datasList).then(res => {
					if(res.code==200){
						this.$message.success('生成凭证成功，请前往凭证列表查看');
					} 
				})
			});

			console.log(this.$refs.table.getSelection());
		},
		//凭证折旧
		handleDevalue(){
			var params ={};
			var idList = new Array();
			var selecttion = this.$refs.table.getSelection();
			if(selecttion==undefined){
				this.$message.error('请选中记录!');
			}
			selecttion.forEach(item =>{
				idList.push(item.id);
			})
			params={
				idList:idList,
				devalueTime:this.formData.month.format('YYYY-MM-DD')
			}
			this.$Confirm("确认折旧选中记录?").then(() => {
				console.log(params);
				this.$api.propertys.devalue(params).then(res  => {
					if(res.code == 200){
						this.loadList();
					}
				})
			})
		},
		handleTBRow(e){
			
			this.showDrawer(e)
		},
		checkSelect(e){ 
			this.propertyDisable = false;
			this.devalueDisable = false;
			if(e.length > 0){ 
				e.forEach(item=>{
					if(item.propertyVoucherId!=undefined && item.propertyVoucherId!=0){
						this.propertyDisable=true;
					}
					if(item.devalueVoucherId!=undefined && item.devalueVoucherId!=0){
						this.devalueDisable=true;
					}
				})
			}
		}
 

	},
	mounted() {

	}
}
</script>


<style lang="less" scoped>
.h-row>div>div {
	padding: 8px;
	border-radius: 5px;
	text-align: center;
	font-size: 20px;
	color: #000;
}

.period {
	border-radius: 3px;
	text-align: center;
	line-height: 54px;
	border: 1px solid @primary-color;
	white-space: nowrap;
	overflow: hidden;
	box-sizing: border-box;
	height: 80px;

	&:hover {
		cursor: pointer;
		box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
	}

	.month-header {
		height: 25px;
		margin: -8px -8px 0 -8px;
	}

	&.completed {
		.month-header {
			background-color: @gray1-color !important;
			line-height: 20px;
		}

		border-color: @gray1-color;

		color: #a2a2a2;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}

	&.disable {
		opacity: 0.4;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}
}

.topselectbox {}

.topselectbox .topselect02 {
	padding-top: 15px;
	padding-left: 20px;
}

.tablebox {
	padding-left: 20px;
	padding-top: 20px;
}

.fiveeditbox {
	width: 500px;
	margin: 0 auto;
}

.fiveeditbox ul li {}

.fiveeditbox ul li p {
	font-size: 15px;
	padding-bottom: 5px;
	padding-top: 10px;
}
.info-title{
	width:100%;padding-left:30px;
	padding-bottom: 15px;
	font-weight: bold;
}
.stamp-image {
//   width: 20px;
//   height: 20px;
  position: absolute;
  top: 145px;
  right: 140px;
}
</style>
